var map = {
	"./close-btn.webp": 1940,
	"./icon-caution.webp": 1941,
	"./icon-checked.webp": 1942,
	"./icon-contact-us.webp": 1943,
	"./icon-email.webp": 1944,
	"./icon-eye-close.webp": 1945,
	"./icon-eye-open.webp": 1946,
	"./icon-forget-phone.webp": 1947,
	"./icon-google.webp": 1948,
	"./icon-login-email.webp": 1949,
	"./icon-password.webp": 1950,
	"./icon-robot-select.webp": 1951,
	"./icon-robot-unselect.webp": 1952,
	"./icon-telegram.webp": 1953,
	"./icon-user.webp": 1954,
	"./login-bg.webp": 1955,
	"./reglogin-bg-bm.webp": 1956,
	"./reglogin-bg-cn.webp": 1957,
	"./reglogin-bg-id.webp": 1958,
	"./reglogin-bg.webp": 1959,
	"./reglogin-m-bg-bm.webp": 1960,
	"./reglogin-m-bg-cn.webp": 1961,
	"./reglogin-m-bg-id.webp": 1962,
	"./reglogin-m-bg.webp": 1963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;